import { z } from 'zod';
import { CursorQuery } from './common/pagination.js';
import { CategoryKey } from './taxonomy.js';
import { ContentBase } from './content.js';
import { Paginated } from './common/pagination.js';
export const RecentActivityQuery = CursorQuery.extend({
    cursor: z.string().min(1).max(2048).optional(),
    category1: CategoryKey.refine((key) => key !== 'main', 'Main is not a category').optional(),
    limit: z.coerce.number().int().min(1).max(20).default(5),
});
export const RecentActivityPage = Paginated(ContentBase);
export const SupportPeopleQuery = CursorQuery.extend({
    direction: z.enum(['supporters', 'supporting']),
    category1: CategoryKey.optional(),
    q: z.string().trim().max(80).optional(),
});
export const SupportPerson = z.object({
    userId: z.string(),
    displayName: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    categories: z.array(CategoryKey),
    since: z.coerce.date(),
});
export const MainProfileSummary = z.object({
    supporters: z.number().int().nonnegative().nullable(),
    supporting: z.number().int().nonnegative().nullable(),
    groups: z.number().int().nonnegative().nullable(),
    pictures: z.number().int().nonnegative().nullable(),
    travel: z
        .object({
        nationsVisited: z.number().int().nonnegative(),
        bucketAchieved: z.number().int().nonnegative(),
        bucketTotal: z.number().int().nonnegative(),
    })
        .nullable(),
    profiles: z.array(z.object({ category: CategoryKey, supporters: z.number().int().nonnegative().nullable() })),
});
//# sourceMappingURL=main-profile.js.map